import { useEffect, useState } from "react";
import { Formik } from "formik";
import { Box, Tab } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { useUserStore } from "../../../hooks/UseUserStore";
import { useCompanyStore } from "../../../hooks/useCompanyStore";
import { TabGeneralData } from "./TabGeneralData";
import { TabPermissions } from "./TabPermissions";
import { TabDocuments } from "./TabDocuments";

type Values = {
    id: number,
    rut: string,
    name: string,
    first_surname: string,
    second_surname: string,
    gender: string,
    type_person: string,
    idprivilege: number,
    age: string,
    birthdate: string,
    email: string,
    phone: string,
    idcompanies: any,
    iduser_type: number,
    password: string,
    password_confirmation: string,
}

export const UserDetailModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, userSelected, listUser, clearState } = props;

    const { createUser, editUser } = useUserStore();
    const { getCompanies } = useCompanyStore();

    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('1');
    const [companies, setCompanies] = useState<any>([]);
    const [data, setData] = useState<Values>({
        id: userSelected ? userSelected.id :'',
        rut: userSelected ? userSelected.rut :'',
        name: userSelected ? userSelected.name :'',
        first_surname: userSelected ? userSelected.first_surname :'',
        second_surname: userSelected ? userSelected.second_surname :'',
        gender: userSelected ? userSelected.gender :'',
        type_person: userSelected ? userSelected.type_person :'',
        idprivilege: userSelected ? userSelected.idprivilege :'',
        age: userSelected ? userSelected.age :'',
        birthdate: userSelected ? userSelected.birthdate :'',
        email: userSelected ? userSelected.email :'',
        phone: userSelected ? userSelected.phone :'',
        idcompanies: userSelected ? userSelected.idcompanies :'',
        iduser_type: userSelected ? userSelected.iduser_type :'',
        password: userSelected ? userSelected.password :'',
        password_confirmation: userSelected ? userSelected.password_confirmation :'',
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.first_surname) errors.first_surname = "el campo es requerido";
        if(!values.second_surname) errors.second_surname = "el campo es requerido";
        if(!values.rut) errors.rut = "el campo es requerido";
        if(!values.gender) errors.gender = "el campo es requerido";
        if(!values.iduser_type) errors.iduser_type = "el campo es requerido";
        if(!values.idprivilege) errors.idprivilege = "el campo es requerido";
        if(!values.age) errors.age = "el campo es requerido";
        if(!values.birthdate) errors.birthdate = "el campo es requerido";
        if(!values.email) errors.email = "el campo es requerido";
        if(!values.phone) errors.phone = "el campo es requerido";
        if(!values.password && !userSelected) errors.password = "el campo es requerido";
        // if(!values.idcompanies) errors.idcompanies = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const idcompanies = (values.idcompanies).map(company => company.id) || [];

        const formdata = {
            ...values,
            type_person: '0',
            age: (values.age).toString(),
            idcompanies: JSON.stringify(idcompanies),
            password_confirmation: values.password,
        }

        if(userSelected){
            const response:any = await editUser(userSelected.id, formdata);
            if(response){
                listUser && listUser();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createUser(formdata);
            if(response){
                listUser && listUser();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" >
            <ModalHeader
                text={'Visualización de los datos del usuario'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Datos generales" value="1" />
                            <Tab label="Permisos" value="2" />
                            <Tab label="Documentos" value="3" />
                            <Tab label="Listas" value="4" />
                            <Tab label="Configuración" value="5" />
                        </TabList>
                    </Box>

                    <TabPanel value="1"> { <TabGeneralData userSelected={userSelected}/> } </TabPanel>
                    <TabPanel value="2"> { <TabPermissions userSelected={userSelected}/> } </TabPanel>
                    <TabPanel value="3"> { <TabDocuments userSelected={userSelected}/> } </TabPanel>
                    <TabPanel value="4">{ 'Lista' }</TabPanel>
                    <TabPanel value="5">{ 'Configuración' }</TabPanel>
                </TabContext>   
            </ModalBody>
        </Modal>
    )
}